"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs — v1
 * API v1 documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPatchDigestSportVisibilityDto = instanceOfPatchDigestSportVisibilityDto;
exports.PatchDigestSportVisibilityDtoFromJSON = PatchDigestSportVisibilityDtoFromJSON;
exports.PatchDigestSportVisibilityDtoFromJSONTyped = PatchDigestSportVisibilityDtoFromJSONTyped;
exports.PatchDigestSportVisibilityDtoToJSON = PatchDigestSportVisibilityDtoToJSON;
exports.PatchDigestSportVisibilityDtoToJSONTyped = PatchDigestSportVisibilityDtoToJSONTyped;
/**
 * Check if a given object implements the PatchDigestSportVisibilityDto interface.
 */
function instanceOfPatchDigestSportVisibilityDto(value) {
    if (!('hidden' in value) || value['hidden'] === undefined)
        return false;
    return true;
}
function PatchDigestSportVisibilityDtoFromJSON(json) {
    return PatchDigestSportVisibilityDtoFromJSONTyped(json, false);
}
function PatchDigestSportVisibilityDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hidden': json['hidden'],
    };
}
function PatchDigestSportVisibilityDtoToJSON(json) {
    return PatchDigestSportVisibilityDtoToJSONTyped(json, false);
}
function PatchDigestSportVisibilityDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'hidden': value['hidden'],
    };
}
